import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import SocialButton from './SocialButton'
import { linkedInAppId } from '../../../config/settings'
import { authSync, displayAlert, changePlayerLocation } from '../../../actions'
import { Auth } from '../../../helpers'

class UserMenu extends Component {
  constructor (props) {
    super(props)

    this.state = {
      location: ''
    }

    this.handleSocialLogin = this.handleSocialLogin.bind(this)
    this.handleSocialLoginFailure = this.handleSocialLoginFailure.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)
  }

  componentDidMount () {
    this.setState({ location: this.props.location })
  }

  handleSocialLogin (profileData) {
    this.props.dismiss()
    profileData = JSON.parse(JSON.stringify(profileData))
    this.props.dispatch(authSync(profileData))
  }

  handleSocialLoginFailure (err) {
    this.props.dismiss()
    err.toString().includes('Authentication failed') &&
      this.props.dispatch(displayAlert('Authentication failed.'))
  }

  handleLocationChange () {
    if (this.state.location === this.props.location) {
      this.props.dispatch(displayAlert('The selected location is in use already.'))
      return
    }
    this.props.dispatch(changePlayerLocation(this.state.location))
  }

  render () {
    return (
      <div className='user-menu'>
        <div className='cursor-pointer menu-link' onClick={() => {
          this.props.dispatch(push('/profile'))
          this.props.dismiss()
        }}>Manage Profile</div>
        <SocialButton
          provider='linkedin'
          appId={linkedInAppId}
          onLoginSuccess={this.handleSocialLogin}
          onLoginFailure={this.handleSocialLoginFailure}>
          Sync with LinkedIn
        </SocialButton>
        {Auth.isAdmin() &&
          <div className='cursor-pointer menu-link'>
            Change Location
            <div className='locator'>
              <select className='search-input location-select' value={this.state.location} onChange={ev => this.setState({ location: ev.target.value })}>
                <option value='Barcelona'>Barcelona</option>
                <option value='Sofia'>Sofia</option>
                <option value='Madrid'>Madrid</option>
                <option value='Amsterdam'>Amsterdam</option>
                <option value='Herzogenaurach'>Herzogenaurach</option>
              </select>
              <button className='button button-sm'
                onClick={this.handleLocationChange}>Go</button>
            </div>
          </div>}
        <div className='cursor-pointer menu-link'
          onClick={() => this.props.dispatch({ type: 'auth/FAIL' })}>Sign Out</div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.auth.user.location
  }
}

export default connect(mapStateToProps)(UserMenu)



// WEBPACK FOOTER //
// ./src/components/common/header/UserMenu.js